import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { TemplateInterface, setEditId, setEditError, selectTemplateById } from "../../../store/roblox/templatesSlice";
import { updateTemplate, fetchTemplate } from "../../../actions/roblox/templatesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch    = useAppDispatch();
  const location    = useLocation();
  const id: any     = useAppSelector(state => state.roblox.templates.editId);
  const error       = useAppSelector(state => state.roblox.templates.editError);
  const template = useAppSelector(state => id ? selectTemplateById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchTemplate(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: TemplateInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: TemplateInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateTemplate({ id, data: formData }));

    if (updateTemplate.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-template'>
        <h6 className="v-content-label">Edit Template</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={template} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
